import React from 'react';
import PropTypes from 'prop-types';
import { Sidebar } from './sidebar/component.js';
import { SystemNotifications } from './system-notifications/component.js';
import { LanguageDropdown } from './LanguageDropdown/component.js';
import { FAIcon } from './fa-icon/component.js';
import { HeaderMenuWrapper } from './HeaderMenuWrapper/component.js';

/*
  Header and Sidebar are functional comps with hooks. These hooks break when pulling
  these directly into a rails file using react_components. This interstitial pre-renders
  the comp as a buffer that prevents the hook-pocalypse. We could expand this to
  include other functional comps with hooks as needed.
*/
var RailsReactHookWrapper = function RailsReactHookWrapper(props) {
  var components = {
    Sidebar: Sidebar,
    HeaderMenuWrapper: HeaderMenuWrapper,
    FAIcon: FAIcon,
    LanguageDropdown: LanguageDropdown,
    SystemNotifications: SystemNotifications
  };
  var Comp = components[props.comp];
  return /*#__PURE__*/React.createElement(Comp, props);
};
RailsReactHookWrapper.displayName = "RailsReactHookWrapper";
RailsReactHookWrapper.displayName = 'RailsReactHookWrapper';
RailsReactHookWrapper.propTypes = {
  comp: PropTypes.string
};
export { RailsReactHookWrapper };